import React, { useCallback, useEffect, useRef, useState } from 'react';
import request from '../../../../../../../helpers/request';
import { baseQueryOptions } from '../../../config/queries';
import { useQuery } from 'react-query';
import generateUrlFromBlob from '../../../../../../../helpers/generateUrlFromBlob';
import { createXlsxBlob } from '../../../lib/file';
import { Button, Spin } from 'antd';
import styles from './Downloader.module.scss';

const fetch = ({ url, errMsg }) => request.get(url, {}, errMsg);

const Downloader = ({ url, errMsg, headers, name }) => {
  const prevFileUrlRef = useRef();
  const [generatedFileUrl, setGeneratedFileUrl] = useState();

  const select = useCallback((data) => {
    if (prevFileUrlRef.current) {
      URL.revokeObjectURL(prevFileUrlRef.current);
    }

    const url = data ? generateUrlFromBlob(data) : data;
    prevFileUrlRef.current = url;
    return url;
  }, []);

  const { data: fetchedFileUrl, isFetching } = useQuery(
    [url],
    () => fetch({ url, errMsg }),
    {
      ...baseQueryOptions,
      staleTime: Infinity,
      enabled: Boolean(url),
      select,
    }
  );

  useEffect(() => {
    if (!headers?.length) {
      setGeneratedFileUrl(undefined);
      return undefined;
    }

    const fileUrl = URL.createObjectURL(createXlsxBlob({ headers }));
    setGeneratedFileUrl(fileUrl);

    return () => URL.revokeObjectURL(fileUrl);
  }, [headers]);

  const fileUrl = fetchedFileUrl || generatedFileUrl;
  const isConfigured = Boolean(url || headers?.length);

  return (
    <Spin spinning={Boolean(isFetching)}>
      {isConfigured && (
        <Button
          type="link"
          href={fileUrl}
          download={name}
          disabled={!fileUrl}
          className={styles.btn}
        >
          {name}
        </Button>
      )}
    </Spin>
  );
};

export default Downloader;
